import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
  name: 'safeHTML',
})
export class SafeHTMLPipe implements PipeTransform {

  constructor(private sanitizer:DomSanitizer){}

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/core/pipes/safeHTML.pipe.ts